import { render, staticRenderFns } from "./repairComment.vue?vue&type=template&id=5888b8e3&scoped=true&"
import script from "./repairComment.vue?vue&type=script&lang=js&"
export * from "./repairComment.vue?vue&type=script&lang=js&"
import style0 from "./repairComment.vue?vue&type=style&index=0&id=5888b8e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5888b8e3",
  null
  
)

component.options.__file = "repairComment.vue"
export default component.exports